<div class="full-screen grid" *ngIf="!registerSuccess">
    <div class="col-8 form-container">
        <h2 class="title">Comprueba que eres tú</h2>
        <p class="subtitle">
            Nos tomamos muy en serio que nuestros usuarios sean humanos reales. Por eso te pedimos que verifiques tu
            documento de identidad, correo y número de celular.
        </p>
        <div class="col-12 md:col-12">
            <p-accordion [activeIndex]="activeTabIndex">
                <!-- Pestaña de verificación de identidad -->
                <p-accordionTab header="{{titleIdentity}}">
                    <div class="col-12 flex flex-wrap align-content-between">
                        <div class="col-12 md:col-4 mb-3 md:mb-0">
                            <p-dropdown
                                    [options]="identityTypes"
                                    [(ngModel)]="selectedIdentityTypes"
                                    placeholder="Seleccione un tipo de documento"
                                    optionLabel="optionName"
                                    optionValue="optionCode">
                            </p-dropdown>
                        </div>
                        <div class="col-12 md:col-8">
                            <p-fileUpload
                                    name="demo[]"
                                    url="https://www.primefaces.org/cdn/api/upload.php"
                                    (onUpload)="onUpload($event)"
                                    [multiple]="true"
                                    accept="image/*"
                                    [maxFileSize]="5000000"
                                    (onSelect)="onSelect($event)"
                                    chooseLabel="Elegir">
                                <ng-template pTemplate="content">
                                    <!-- Estado vacío -->
                                    <div *ngIf="filesSelect.length === 0"
                                         class="empty-upload-container flex align-items-center justify-content-center flex-column">
                                        <i class="pi pi-id-card border-2 border-circle p-5 text-8xl text-400 border-400"></i>
                                        <p class="mt-4 mb-0">Documento de identidad.</p>
                                    </div>
                                    <!-- Estado de archivos subidos -->
                                    <ul *ngIf="filesUploaded" class="file-list">
                                        <li *ngFor="let file of files"
                                            class="m-0 px-6 flex flex-column align-items-center gap-3">
                                            <img role="presentation" [alt]="file.name" [src]="file.objectURL"
                                                 class="responsive-image">
                                            <p-badge value="Imagen subida exitosamente" class="mt-3"
                                                     severity="success"></p-badge>
                                        </li>
                                    </ul>
                                </ng-template>
                            </p-fileUpload>
                        </div>
                    </div>
                </p-accordionTab>
                <p-accordionTab header="{{titleEmail}}">
                    <p>Enviamos un código de verificación a tu correo electrónico.</p>
                    <p>Ingrésalo para continuar.</p>
                    <div class="code-inputs">
                        <!-- Inputs del código de verificación -->
                        <p-inputNumber [(ngModel)]="valEmail1" inputStyleClass="w-3rem text-center" [maxlength]="1" (onInput)="focusOnNext(input2)"></p-inputNumber>
                        <p-inputNumber #input2 [(ngModel)]="valEmail2" inputStyleClass="w-3rem text-center" [maxlength]="1" (onInput)="focusOnNext(input3)"></p-inputNumber>
                        <p-inputNumber #input3 [(ngModel)]="valEmail3" inputStyleClass="w-3rem text-center" [maxlength]="1" (onInput)="focusOnNext(input4)"></p-inputNumber>
                        <p-inputNumber #input4 [(ngModel)]="valEmail4" inputStyleClass="w-3rem text-center" [maxlength]="1" (onInput)="focusOnNext(input5)"></p-inputNumber>
                        <p-inputNumber #input5 [(ngModel)]="valEmail5" inputStyleClass="w-3rem text-center" [maxlength]="1"(onInput)="focusOnNext(input6)"></p-inputNumber>
                        <p-inputNumber #input6 [(ngModel)]="valEmail6" inputStyleClass="w-3rem text-center" [maxlength]="1"></p-inputNumber>
                    </div>
                </p-accordionTab>

                <!-- Pestaña de verificación de celular -->
                <p-accordionTab header="Verifica tu celular">
                    <p>Enviamos un código de verificación a tu celular. Ingrésalo para continuar.</p>
                    <div class="code-inputs">
                        <!-- Inputs del código de verificación -->
                        <p-inputNumber [(ngModel)]="val1" inputStyleClass="w-3rem text-center" [maxlength]="1" (onInput)="focusOnNext(input2)"></p-inputNumber>
                        <p-inputNumber #input2 [(ngModel)]="val2" inputStyleClass="w-3rem text-center" [maxlength]="1" (onInput)="focusOnNext(input3)"></p-inputNumber>
                        <p-inputNumber #input3 [(ngModel)]="val3" inputStyleClass="w-3rem text-center" [maxlength]="1" (onInput)="focusOnNext(input4)"></p-inputNumber>
                        <p-inputNumber #input4 [(ngModel)]="val4" inputStyleClass="w-3rem text-center" [maxlength]="1" (onInput)="focusOnNext(input5)"></p-inputNumber>
                        <p-inputNumber #input5 [(ngModel)]="val5" inputStyleClass="w-3rem text-center" [maxlength]="1"(onInput)="focusOnNext(input6)"></p-inputNumber>
                        <p-inputNumber #input6 [(ngModel)]="val6" inputStyleClass="w-3rem text-center" [maxlength]="1"></p-inputNumber>

                    </div>
                </p-accordionTab>
            </p-accordion>
            <form [formGroup]="identityForm" (ngSubmit)="onSubmit()">
                <!-- Checkbox de términos y condiciones -->
                <div class="col-12 flex align-items-start mb-3">
                    <p-checkbox [binary]="true" formControlName="termsAccepted"></p-checkbox>
                    <label class="checkbox-label">
                        Estoy de acuerdo con que se procese mi información para verificar mi identidad
                        conforme a lo establecido en la <a href="#">Política de Privacidad</a> y
                        los <a href="#">Términos & Condiciones</a> de Tadic List.
                    </label>
                    <br>
                </div>
                <div class="error-message">
                    <ul class="text-danger list-unstyled"
                        *ngIf="isNotDataValid || identityForm.controls['termsAccepted'].dirty">
                        <li *ngFor="let error of getValidationMessages('termsAccepted')">
                            <p-message severity="error" [text]="error"
                                       *ngIf="!identityForm.controls['termsAccepted'].valid"></p-message>
                        </li>
                    </ul>
                </div>
                <!-- Botones de acción -->
                <div class="col-12 flex flex-wrap gap-2 md:flex-row md:justify-content-start justify-content-center">
                    <button pButton (click)="navigateToOtherComponent()" type="button"
                            class="p-button-rounded custom-button col-12 md:col-5">
                        <span>Verificar más tarde</span>
                    </button>
                    <button pButton type="submit" class="p-button-rounded custom-button col-12 md:col-5"
                            [disabled]="!activeCellTab || identityForm.invalid">
                        <span>Verificar y continuar</span>
                        <i class="pi pi-arrow-right ml-2"></i>
                    </button>
                </div>

            </form>
        </div>
    </div>
</div>

<div class="full-screen" *ngIf="registerSuccess">
    <div class="col-8 form-container">
        <h2 class="title">¡Listo, ya estás dentro!</h2>
        <p class="subtitle">
            Te registraste y verificaste correctamente. Ahora puedes navegar TadicList y encontrar la propiedad o
            interesado perfecto.
        </p>
        <div class="col-12">
            <p-accordion>
                <p-accordionTab header="Identidad verificada" [disabled]="true"></p-accordionTab>
                <p-accordionTab header="Email verificado" [disabled]="true"></p-accordionTab>
                <p-accordionTab header="Celular verificado" [disabled]="true"></p-accordionTab>
            </p-accordion>

            <!-- Botón Crear Cuenta -->
            <div class="col-12 flex-row">
                <button pButton (click)="navigateToOtherComponent()" type="submit"
                        class="p-button-rounded custom-button">
                    <span>Navegar</span>
                    <i class="pi pi-arrow-right ml-2"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<p-toast></p-toast> <!-- Componente para mostrar notificaciones -->
